import React from "react";
import { Stack, Typography } from "@mui/material";

import { Organisation, User } from "../../../types";
import CardsViewShell from "../../../components/views/cards-view-shell";
import UserCard from "./user-card";

interface UsersCardsViewProps {
  filteredUsers: User[];
  unfilteredUserCount: number;
  teamDictionary: Record<string, Organisation>;
}

const UsersCardsView: React.FC<UsersCardsViewProps> = ({
  filteredUsers,
  unfilteredUserCount,
  teamDictionary,
}) => {
  if (filteredUsers.length === 0) {
    return (
      <Stack
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 200,
          flexDirection: "column",
        }}
      >
        <Typography variant="h6" color="text.secondary">
          No users found
        </Typography>
      </Stack>
    );
  }

  return (
    <CardsViewShell shownCount={filteredUsers.length} totalCount={unfilteredUserCount}>
      {filteredUsers.map((user) => {
        const teams = user.organisationIds
          .map((teamId) => teamDictionary[teamId] || null)
          .filter((team): team is Organisation => team !== null);

        return (
          <UserCard
            key={user.userId}
            user={user}
            teams={teams}
          />
        );
      })}
    </CardsViewShell>
  );
};

export default UsersCardsView;
